//
// Components related events
//

const App = $('#GimmeApp');

const AppEvents = {
  spinner: 'SPINNER',
  fbSuccess: 'FB.SUCCESS'
};

App.on(AppEvents.fbSuccess, (e, appUserConfig, callbackData) => fbSuccessResponse(appUserConfig, callbackData));

//
// API endpoints
//

const $apiData = $('.js-api-data');

//
// FB success response
//

var fbSuccessResponse = () => location.href = location.protocol + '//' + location.host + $apiData.data('resultPath');
